// ----- Imports ----- //
import { contributionsOnlyCountries } from '@modules/internationalisation/contributionsOnlyCountries';
const defaultConfig = {
    ANNUAL: {
        min: 10,
        max: 2000,
    },
    MONTHLY: {
        min: 2,
        max: 166,
    },
    ONE_OFF: {
        min: 1,
        max: 2000,
    },
};
// Note: ONE_OFF max amounts are also validated on the server, in Currency.scala, and
// should be kept in sync.
const config = {
    GBPCountries: defaultConfig,
    AUDCountries: {
        ANNUAL: defaultConfig.ANNUAL,
        MONTHLY: {
            min: 2,
            max: 200,
        },
        ONE_OFF: {
            min: 1,
            max: 25000,
        },
    },
    EURCountries: {
        ANNUAL: defaultConfig.ANNUAL,
        MONTHLY: {
            min: 2,
            max: 166,
        },
        ONE_OFF: defaultConfig.ONE_OFF,
    },
    UnitedStates: {
        ANNUAL: {
            ...defaultConfig.ANNUAL,
            max: 10000,
        },
        MONTHLY: {
            min: 2,
            max: 800,
        },
        ONE_OFF: {
            ...defaultConfig.ONE_OFF,
            max: 10000,
        },
    },
    International: {
        ANNUAL: defaultConfig.ANNUAL,
        MONTHLY: {
            min: 2,
            max: 166,
        },
        ONE_OFF: defaultConfig.ONE_OFF,
    },
    NZDCountries: {
        ANNUAL: defaultConfig.ANNUAL,
        MONTHLY: {
            min: 2,
            max: 200,
        },
        ONE_OFF: defaultConfig.ONE_OFF,
    },
    Canada: {
        ANNUAL: defaultConfig.ANNUAL,
        MONTHLY: {
            min: 2,
            max: 166,
        },
        ONE_OFF: defaultConfig.ONE_OFF,
    },
};
const contributionsOnlyCountriesAmountsConfig = {
    defaultContributionType: 'MONTHLY',
    displayContributionType: ['ONE_OFF', 'MONTHLY', 'ANNUAL'],
    amountsCardData: {
        ONE_OFF: {
            amounts: [1, 2, 5, 10],
            defaultAmount: 2,
            hideChooseYourAmount: true,
        },
        MONTHLY: {
            amounts: [2, 3, 5, 7, 9, 12],
            defaultAmount: 5,
            hideChooseYourAmount: true,
        },
        ANNUAL: {
            amounts: [10, 15, 20, 30],
            defaultAmount: 15,
            hideChooseYourAmount: true,
        },
    },
};
const countries = new Set(contributionsOnlyCountries);
const isContributionsOnlyCountry = (countryId) => countries.has(countryId);
// ----- Exports ----- //
export { config, isContributionsOnlyCountry, contributionsOnlyCountriesAmountsConfig, };
